import axios from 'axios';

export function ajaxGet(url, successCb, errorCb = (error) => { console.log(error); }) {
  const csrfToken = document.querySelector('meta[name=csrf-token]') ? document.querySelector('meta[name=csrf-token]').content : null;

  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

  axios.get(url)
    .then((response) => {
      successCb(response);
    })
    .catch((error) => {
      errorCb(error);
    });
}

export function getAjaxModal(modalPath, successCb = () => {}, errorCb = (error) => { console.log(error); }) {
  ajaxGet(
    modalPath,
    (response) => {
      eval(response.data); // eslint-disable-line no-eval

      successCb();
    },
    errorCb,
  );
}
